import { useContactManagementTranslation } from '../../../../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
export function showAccountsCannotBeAddedToOrganizationsDialog(params) {
    showCustomDialog({
        maxWidth: 'sm',
        content: (close) => React.createElement(AccountsCannotBeAddedToOrganizationsDialogContent, Object.assign({}, params, { onClose: close })),
    });
}
const AccountsCannotBeAddedToOrganizationsDialogContent = ({ accountRejectedOrganizationsRows, onClose, onConfirm, }) => {
    const { t } = useContactManagementTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('panels.organizations.membershipLimitValidation.dialog.title')),
        React.createElement(DialogContent, null,
            React.createElement(Box, { sx: { backgroundColor: themeColors.surface.secondary, p: 2, mb: 2 } },
                React.createElement(Typography, { sx: { mb: 2 } }, t('panels.organizations.membershipLimitValidation.dialog.description')),
                React.createElement(DataTable, { loading: false, rows: accountRejectedOrganizationsRows.map((i) => (Object.assign(Object.assign({}, i), { id: i.accountId }))), columns: [
                        {
                            headerLabel: t('panels.organizations.membershipLimitValidation.table.header.account'),
                            cellField: 'accountName',
                        },
                        {
                            headerLabel: t('panels.organizations.membershipLimitValidation.table.header.cannotBeAddedTo'),
                            cellFunction: (row) => {
                                return React.createElement(Typography, { variant: 'body2' }, row.organizations.map((org) => org.name).join(', '));
                            },
                            tableCellSx: {
                                width: '50%',
                            },
                        },
                    ] })),
            React.createElement(Alert, { severity: 'info' }, t('panels.organizations.membershipLimitValidation.dialog.alert'))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => onClose() }, t('common.cancel')),
            React.createElement(Button, { color: 'primary', onClick: () => {
                    onConfirm();
                    onClose();
                } }, t('common.continue')))));
};
